import {
  LayoutDashboard,
  Truck,
  History,
  DollarSign,
  Users,
  Car,
  Settings,
} from 'lucide-react';

/**
 * Configuration centralisée des liens de navigation pour la sidebar transporteur
 * Utilisée par toutes les pages transporteur pour garantir la cohérence
 * 
 * @param {Object} stats - Statistiques du transporteur (optionnel, pour les badges)
 * @returns {Array} Liste des liens de navigation
 */
export const getTransporterSidebarLinks = (stats = {}) => [
  {
    to: '/transporter/dashboard',
    label: 'Tableau de bord',
    icon: LayoutDashboard,
  },
  {
    to: '/transporter/missions-requests',
    label: 'Missions & Demandes',
    icon: Truck,
    badge: stats.nouvelles_demandes > 0 ? stats.nouvelles_demandes : undefined,
  },
  {
    to: '/transporter/vehicles',
    label: 'Véhicules',
    icon: Car,
  },
  {
    to: '/transporter/drivers',
    label: 'Chauffeurs',
    icon: Users,
  },
  {
    to: '/transporter/earnings',
    label: 'Revenus',
    icon: DollarSign,
  },
  {
    to: '/transporter/history',
    label: 'Historique',
    icon: History,
  },
  {
    to: '/transporter/settings',
    label: 'Paramètres',
    icon: Settings,
  },
];

export default getTransporterSidebarLinks;

